var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M458.732 422.212 435.87 134.103c-1.419-18.563-17.124-33.098-35.737-33.098h-45.164v66.917c0 8.287-6.708 14.995-14.995 14.995-8.277 0-14.995-6.708-14.995-14.995v-66.917H187.028v66.917c0 8.287-6.718 14.995-14.995 14.995-8.287 0-14.995-6.708-14.995-14.995v-66.917h-45.164c-18.613 0-34.318 14.535-35.737 33.058L53.265 422.252c-1.769 23.082 6.238 46.054 21.962 63.028C90.952 502.253 113.244 512 136.386 512h239.236c23.142 0 45.434-9.747 61.159-26.721 15.724-16.974 23.731-39.946 21.951-63.067zM323.56 275.493l-77.553 77.553a14.958 14.958 0 0 1-10.606 4.398 14.956 14.956 0 0 1-10.606-4.398l-36.347-36.347c-5.858-5.858-5.858-15.345 0-21.203 5.858-5.858 15.355-5.858 21.203 0l25.751 25.741 66.956-66.956c5.848-5.848 15.345-5.848 21.203 0 5.857 5.858 5.857 15.354-.001 21.212zM256.004 0c-54.571 0-98.965 44.404-98.965 98.975v2.029h29.99v-2.029c0-38.037 30.939-68.986 68.976-68.986s68.976 30.949 68.976 68.986v2.029h29.989v-2.029C354.969 44.404 310.575 0 256.004 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.8bb83e83f10e3c7bb79d923c4de68277.svg";
export { ForwardRef as ReactComponent };